import {BrowserRouter , Routes, Route} from 'react-router-dom';
import { useLocation, useNavigate } from 'react-router-dom';
import "primereact/resources/themes/lara-light-cyan/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";
import LoginPage from './pages/login';
import ProtectedRoute from './pages/common/ProtectedRoute';
import TopMenu from './Layouts/SideMenu';
import FirmClients from './pages/FirmClients';
import Home from './pages/Home';
import Messages from './pages/Messages';
import GenerateCUDORDS from './pages/GenerateCUDORDS';
import { useEffect } from 'react';

function Layout() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(()=> {
    const expiryTime = localStorage.getItem("expiryTime");
    if(expiryTime) {
      const currentTime = new Date().getTime();
      const timeLeft = Number(expiryTime) - currentTime;
      if(timeLeft <= 0) {
        logout();
      } else {
        const timer = setTimeout(() => {
          logout();
        }, timeLeft);
        return () => clearTimeout(timer);
      }
    }
  }, []);

  const logout = () => {
    localStorage.clear();
    alert("Session expired. Please login again.");
    navigate("/login")
  }
  return (
    <div>
        <>
        {location.pathname !=="/" && location.pathname !=="/login" && <TopMenu/>}
         <Routes>
          <Route path="/login" element={<LoginPage />} />
           <Route path="/">
            <Route index element={<LoginPage/>} />
          </Route>
          <Route path="/Pages/Home">
            <Route index element={<ProtectedRoute><Home /></ProtectedRoute>} />
          </Route>
          <Route path="/Pages/FirmClients">
            <Route index element={<ProtectedRoute><FirmClients /></ProtectedRoute>} />
          </Route>
          <Route path="/Pages/Messages">
            <Route index element={<ProtectedRoute><Messages /></ProtectedRoute>} />
          </Route>
          <Route path="/Pages/GenerateCUDORDS">
            <Route index element={<ProtectedRoute><GenerateCUDORDS /></ProtectedRoute>} />
          </Route>
         </Routes>
       </>
      {/* <h1>Hello World !!!</h1> */}
    </div>
  );
}

function App() {
  return (
  <BrowserRouter>
    <Layout />
  </BrowserRouter>
  );
}

export default App;
